import { Component } from '@angular/core';

@Component({
	selector: 'vh-root',
	templateUrl: './bootstrap.component.html',
	styleUrls: ['./bootstrap.component.scss']
})
export class BootstrapComponent {}
